import React from 'react'
import BreadcrumbComp from "../layouts/BreadcrumbComp";
import { menuActions } from "../../store/menu-slice";
import { useDispatch } from "react-redux";

const Dashboard = () => {
  const dispatch = useDispatch();
  dispatch(menuActions.setMenu("Dashboard"));
  return (
    <>
      <BreadcrumbComp />
      <div style={{ textAlign: 'center', marginTop: '5%' }}><h2>Dashboard</h2></div>
    </>
  )
}
export default Dashboard
